export const SEARCH_EXTENSION_VERSION_1 = '1';
export const SEARCH_EXTENSION_KEY = 'company-hub-search';
export const SEARCH_EXTENSION_TYPE = 'com.atlassian.confluence.company-hub-search';

export const CUSTOM_SEARCH_EXTENSION_ANALYTIC_SOURCE = 'customSearchExtension';
